<template>
  <div class="app-container">
    <!-- 導覽列 -->
    <nav class="navbar">
      <div class="navbar-content">
        <h1 class="site-title">後台管理系統</h1>
        <button class="menu-toggle" @click="toggleSidebar">
          <span class="hamburger-icon">☰</span>
        </button>
      </div>
    </nav>

    <!-- 側邊欄遮罩 -->
    <div
      class="sidebar-overlay"
      :class="{ show: sidebarOpen }"
      @click="closeSidebar"
    ></div>

    <!-- 側邊欄 -->
    <aside class="sidebar" :class="{ open: sidebarOpen }">
      <nav class="sidebar-nav">
        <RouterLink
          v-if="userPermissions.Dashboard"
          to="/admin/dashboard"
          class="menu-item"
          @click="closeSidebar"
        >
          <img src="@/assets/image/icon/sale.png" class="all-icon" />
          <span class="menu-text">儀表板</span>
        </RouterLink>

        <RouterLink
          v-if="userPermissions.MemberManage"
          to="/admin/customer"
          class="menu-item"
          @click="closeSidebar"
        >
          <img src="@/assets/image/icon/users-alt.png" class="all-icon" />
          <span class="menu-text">會員管理</span>
        </RouterLink>

        <RouterLink
          v-if="userPermissions.OrderManage"
          to="/admin/order"
          class="menu-item"
          @click="closeSidebar"
        >
          <img src="@/assets/image/icon/rectangle-list.png" class="all-icon" />
          <span class="menu-text">訂單管理</span>
        </RouterLink>

        <RouterLink
          v-if="userPermissions.ProductManage"
          to="/admin/products"
          class="menu-item"
          @click="closeSidebar"
        >
          <img src="@/assets/image/icon/supplies.png" class="all-icon" />
          <span class="menu-text">商品管理</span>
        </RouterLink>

        <RouterLink
          v-if="userPermissions.CategoryManage"
          to="/admin/category"
          class="menu-item"
          @click="closeSidebar"
        >
          <img src="@/assets/image/icon/brand.png" class="all-icon" />
          <span class="menu-text">類別管理</span>
        </RouterLink>

        <!-- ✅ 新增：橫幅管理 -->
        <RouterLink
          v-if="userPermissions.BannerManage"
          to="/admin/banner"
          class="menu-item"
          @click="closeSidebar"
        >
          <img src="@/assets/image/icon/picture.png" class="all-icon" />
          <span class="menu-text">橫幅管理</span>
        </RouterLink>

        <RouterLink
          v-if="userPermissions.MarketingManage"
          to="/admin/market"
          class="menu-item"
          @click="closeSidebar"
        >
          <img src="@/assets/image/icon/megaphone.png" class="all-icon" />
          <span class="menu-text">行銷管理</span>
        </RouterLink>

        <RouterLink
          v-if="userPermissions.InventoryManage"
          to="/admin/sale"
          class="menu-item"
          @click="closeSidebar"
        >
          <img src="@/assets/image/icon/box.png" class="all-icon" />
          <span class="menu-text">庫存管理</span>
        </RouterLink>

        <RouterLink
          v-if="userPermissions.ReturnManage"
          to="/admin/return"
          class="menu-item"
          @click="closeSidebar"
        >
          <img src="@/assets/image/icon/return-box.png" class="all-icon" />
          <span class="menu-text">退換貨管理</span>
        </RouterLink>

        <div class="menu-divider"></div>

        <RouterLink
          v-if="userPermissions.AccountManage"
          to="/admin/account"
          class="menu-item"
          @click="closeSidebar"
        >
          <img src="@/assets/image/icon/settings.png" class="all-icon" />
          <span class="menu-text">管理帳號設定</span>
        </RouterLink>

        <RouterLink
          v-if="userPermissions.PermissionManage"
          to="/admin/permissions"
          class="menu-item"
          @click="closeSidebar"
        >
          <img src="@/assets/image/icon/key.png" class="all-icon" />
          <span class="menu-text">管理權限設定</span>
        </RouterLink>
      </nav>

      <!-- 登出按鈕區域 (獨立在外) -->
      <div class="sidebar-footer">
        <button class="logout-button" @click="handleLogout">
          <span class="logout-text">登出系統</span>
        </button>
      </div>
    </aside>

    <!-- 主要內容 -->
    <main class="main-content">
      <router-view />
    </main>
  </div>
</template>

<script>
import Swal from "sweetalert2"; // 引入 SweetAlert2
import api from "@/assets/js/utils/api";
import router from "@/router";
export default {
  name: "SidebarControl", // 元件名稱

  data() {
    return {
      sidebarOpen: false, // 控制側邊欄開關狀態
      userPermissions: {
        Dashboard: false,
        MemberManage: false,
        OrderManage: false,
        ProductManage: false,
        CategoryManage: false,
        BannerManage: false,
        MarketingManage: false,
        InventoryManage: false,
        ReturnManage: false,
        AccountManage: false,
        PermissionManage: false,
      },
    };
  },

  watch: {
    // 監聽路由切換時觸發
    $route() {
      // 當螢幕寬度小於768時(手機模式)，自動關閉側邊欄
      if (window.innerWidth < 768) {
        this.closeSidebar(); // 呼叫關閉方法
      }
    },
  },

  methods: {
    // 切換側邊欄開關
    toggleSidebar() {
      this.sidebarOpen = !this.sidebarOpen; // 開關切換
    },

    // 關閉側邊欄
    closeSidebar() {
      this.sidebarOpen = false; // 設為關閉狀態
    },

    async fetchUserPermissions() {
      try {
        const res = await api.get("/employee/permission");
        if (res.data && res.data.data) {
          this.userPermissions = res.data.data;
          console.log("✅ 成功獲取用戶權限", this.userPermissions);
        }
      } catch (error) {
        console.warn("獲取用戶權限失敗：", error);
      }
    },

    async handleLogout() {
      try {
        await api.post("/employee/logout"); // 🔥 用 axios 統一走攔截器

        // 清除本地資訊
        localStorage.removeItem("token");
        localStorage.removeItem("role");
        localStorage.removeItem("employeeName");

        // 清除路由守卫儲存的權限快取
        window.cachedUserPermissions = null;

        Swal.fire({
          icon: "success",
          title: "已成功登出",
          text: "期待再次使用 🐾",
          timer: 1500,
          showConfirmButton: false,
        });

        router.push("/login");
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "登出失敗",
          text: "請稍後再試！",
        });
      }
    },
  },

  mounted() {
    this.fetchUserPermissions(); // 加載用戶權限
  },
};
</script>

<style scoped src="@/assets/css/layout.css"></style>
